import { render, staticRenderFns } from "./test1-4.vue?vue&type=template&id=5d713ef0&scoped=true"
import script from "./test1-4.vue?vue&type=script&lang=js"
export * from "./test1-4.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/page.css?vue&type=style&index=0&id=5d713ef0&prod&scoped=true&lang=css&external"
import style1 from "./test1-4.vue?vue&type=style&index=1&id=5d713ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d713ef0",
  null
  
)

export default component.exports